import { render } from "./LabPaid3Payment.vue?vue&type=template&id=86f8706c"
import script from "./LabPaid3Payment.vue?vue&type=script&lang=js"
export * from "./LabPaid3Payment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__